var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGainedKeywords(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5214 22.0667L56.8101 24.3554L44.6755 36.49L37.3132 29.264C36.9104 28.8686 36.2643 28.8716 35.8652 29.2707L17.5513 47.5846C17.1446 47.9913 17.1504 48.6526 17.5642 49.0521L20.4248 51.814C20.8298 52.2051 21.474 52.1979 21.8702 51.7979L36.5858 36.9394L43.9448 44.2983C44.3478 44.7014 45.0018 44.6999 45.403 44.295L61.0048 28.5501L63.0088 30.474C63.6627 31.1017 64.75 30.6383 64.75 29.7318V21.3393C64.75 20.7711 64.2894 20.3105 63.7213 20.3105H55.2488C54.3323 20.3105 53.8733 21.4186 54.5214 22.0667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9291 61.6893H29.864C30.4322 61.6893 30.8928 61.2287 30.8928 60.6606V46.8267L24.9004 52.819V60.6606C24.9004 61.2287 25.361 61.6893 25.9291 61.6893Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6635 61.6895H42.5984C43.1666 61.6895 43.6271 61.2289 43.6271 60.6607V48.3249L37.6348 42.3325V60.6607C37.6348 61.2289 38.0953 61.6895 38.6635 61.6895Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3979 61.6893H55.3328C55.9009 61.6893 56.3615 61.2287 56.3615 60.6606V37.3887L50.3691 43.381V60.6606C50.3691 61.2287 50.8297 61.6893 51.3979 61.6893Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGainedKeywords);
export default __webpack_public_path__ + "static/media/GainedKeywords.aabdf393f439047da950e14f4dc9ab2f.svg";
export { ForwardRef as ReactComponent };